import type { FC } from 'react';

import { BestRateItem } from '@/components/BestRatesList/parts/BestRateItem';
import type { IRateInBestRatesProps } from '@/types';
import { cn } from '@/utils';

interface PromotionalDepositsListProps {
  rates: IRateInBestRatesProps[];
  className?: string;
  itemClassName?: string;
}
export const BestRatesList: FC<PromotionalDepositsListProps> = ({
  rates,
  className,
  itemClassName,
}) => {
  return (
    <div
      className={cn(
        '-mx-5 bg-white md:bg-blue-50 flex justify-between gap-6 overflow-x-scroll px-5 md:mx-0 md:gap-0 md:overflow-hidden md:rounded-3xl md:px-6 md:py-5',
        className,
      )}
    >
      {rates.map((rate, index) => {
        return (
          <>
            <BestRateItem
              depositTypeKey={rate.depositTypeKey}
              rate={rate.rate}
              url={rate.url}
              term={rate.term}
              currency={rate.currency}
              itemClassName={itemClassName}
            />
            {index < 2 && (
              <span className="mx-8 hidden h-[80px] w-[1px] shrink-0 self-center bg-blue-100 md:block" />
            )}
          </>
        );
      })}
    </div>
  );
};
